import reducer from './reducer';

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/modules/charity/index.ts